export default "__VITE_ASSET__CTdC4CYW__"